<template>
  <table class="overview">
    <tbody>
      <tr>
        <th>{{$t('street_address')}}</th>
        <td colspan="3">{{propertyDetail.street_address}}</td>
      </tr>
      <template v-if="propertyDetail.type === 'business'">
        <tr>
          <th>{{$t('property_price')}}</th>
          <td>{{formatPrice(propertyDetail.property_price)}}</td>
          <th>{{$t('building_price')}}</th>
          <td>{{formatPrice(propertyDetail.building_price)}}</td>
        </tr>
        <tr>
          <th>{{$t('land_price')}}</th>
          <td>{{formatPrice(propertyDetail.land_price)}}</td>
          <th>{{$t('yields')}}</th>
          <td><template v-if="propertyDetail.yields">{{propertyDetail.yields}}%</template></td>
        </tr>
        <tr>
          <th>{{$t('estimated_annual_income')}}</th>
          <td>{{formatPrice(propertyDetail.estimated_annual_income)}}</td>
          <th>{{$t('building_area')}}</th>
          <td><template v-if="propertyDetail.building_area">{{propertyDetail.building_area}} <span>m<sup>2</sup></span></template></td>
        </tr>
        <tr>
          <th>{{$t('land_area')}}</th>
          <td><template v-if="propertyDetail.land_area">{{propertyDetail.land_area}} <span>m<sup>2</sup></span></template></td>
          <th>{{$t('date_of_construction')}}</th>
          <td>{{propertyDetail.date_of_construction}}</td>
        </tr>
        <tr>
          <th>{{$t('floor')}}</th>
          <td>{{propertyDetail.floor}}</td>
          <th>{{$t('construction')}}</th>
          <td>{{propertyDetail.construction}}</td>
        </tr>
        <tr>
          <th>{{$t('unit_price')}}</th>
          <td>{{propertyDetail.unit_price}}</td>
          <th>{{$t('total_unit')}}</th>
          <td>{{propertyDetail.total_unit}}</td>
        </tr>
        <tr>
          <th>{{$t('number_of_unit_sold')}}</th>
          <td>{{propertyDetail.number_of_unit_sold}}</td>
          <th>{{$t('building_coverage_ratio')}}</th>
          <td><template v-if="propertyDetail.building_coverage_ratio">{{propertyDetail.building_coverage_ratio}}%</template></td>
        </tr>
        <tr>
          <th>{{$t('floor_area_ratio')}}</th>
          <td><template v-if="propertyDetail.floor_area_ratio">{{propertyDetail.floor_area_ratio}}%</template></td>
          <th>{{$t('setback')}}</th>
          <td>{{propertyDetail.setback}}</td>
        </tr>
        <tr>
          <th>{{$t('floor_plan_type')}}</th>
          <td>{{propertyDetail.floor_plan_type}}</td>
          <th>{{$t('floor_plan_details')}}</th>
          <td>{{propertyDetail.floor_plan_details}}</td>
        </tr>
        <tr>
          <th>{{$t('facility')}}</th>
          <td>{{propertyDetail.facility}}</td>
          <th>{{$t('current_situation')}}</th>
          <td>{{propertyDetail.current_situation}}</td>
        </tr>
        <tr>
          <th>{{$t('land_rights')}}</th>
          <td>{{propertyDetail.land_rights}}</td>
          <th>{{$t('ground')}}</th>
          <td>{{propertyDetail.ground}}</td>
        </tr>
        <tr>
          <th>{{$t('area_of_use')}}</th>
          <td>{{propertyDetail.area_of_use}}</td>
          <th>{{$t('city_planning')}}</th>
          <td>{{propertyDetail.city_planning}}</td>
        </tr>
        <tr>
          <th>{{$t('parking_lot')}}</th>
          <td>{{propertyDetail.parking_lot}}</td>
          <th>{{$t('roadside_situation')}}</th>
          <td>{{propertyDetail.roadside_situation}}</td>
        </tr>
        <tr>
          <th>{{$t('driveway_burden')}}</th>
          <td>{{propertyDetail.driveway_burden}}</td>
          <th>{{$t('main_lighting_surface')}}</th>
          <td>{{propertyDetail.main_lighting_surface}}</td>
        </tr>
        <tr>
          <th>{{$t('delivery_date')}}</th>
          <td>{{propertyDetail.delivery_date}}</td>
          <th>{{$t('transaction_mode')}}</th>
          <td>{{propertyDetail.transaction_mode}}</td>
        </tr>
        <tr>
          <th>{{$t('information_disclousure_date')}}</th>
          <td>{{propertyDetail.information_disclousure_date}}</td>
          <th>{{$t('inspection_certificate')}}</th>
          <td>{{propertyDetail.inspection_certificate}}</td>
        </tr>
        <tr>
          <th>{{$t('remarks')}}</th>
          <td>{{propertyDetail.remarks}}</td>
        </tr>
      </template>
      <template v-if="propertyDetail.type === 'rental-residential'">
        <tr>
          <th>{{$t('nearest_station')}}</th>
          <td colspan="3" v-html="sanitize(propertyDetail.nearest_station)"></td>
        </tr>
        <tr>
          <th>{{$t('rent')}}（{{$t('administrative_fee')}}）</th>
          <td>{{propertyDetail.rent}}{{propertyDetail.administrative_fee ? `（${propertyDetail.administrative_fee}）`: ''}}</td>
          <th>{{$t('security_deposit')}}／{{$t('key_money')}}／{{$t('intermediary_charge')}}</th>
          <td v-html="ski_html"></td>
        </tr>
        <tr>
          <th>{{$t('guarantee_consignment_fee')}}</th>
          <td>{{propertyDetail.guarantee_consignment_fee}}</td>
          <th>{{$t('nonlife_insurance')}}</th>
          <td>{{propertyDetail.nonlife_insurance}}</td>
        </tr>
        <tr>
          <th>{{$t('renewal_fee')}}／{{$t('renewal_office_fee')}}</th>
          <td v-html="rr_html"></td>
          <th>{{$t('other_fee')}}</th>
          <td v-html="sanitize(propertyDetail.other_fee)"></td>
        </tr>
        <tr>
          <th>{{$t('floor_plan_details')}}</th>
          <td v-html="sanitize(propertyDetail.floor_plan_details)"></td>
          <th>{{$t('bearing')}}</th>
          <td>{{propertyDetail.bearing}}</td>
        </tr>
        <tr>
          <th>{{$t('property_type')}}／{{$t('construction')}}</th>
          <td v-html="pc_html"></td>
          <th>{{$t('building_floor_portion')}}</th>
          <td>{{propertyDetail.building_floor_portion}}</td>
        </tr>
        <tr>
          <th>{{$t('parking_lot')}}</th>
          <td>{{propertyDetail.parking_lot}}</td>
          <th>{{$t('date_of_construction')}}</th>
          <td>{{propertyDetail.date_of_construction}}</td>
        </tr>
        <tr>
          <th>{{$t('time_of_tenancy')}}</th>
          <td>{{propertyDetail.time_of_tenancy}}</td>
          <th>{{$t('room_category')}}</th>
          <td>{{propertyDetail.room_category}}</td>
        </tr>
        <tr>
          <th>{{$t('type_of_contract')}}</th>
          <td>{{propertyDetail.type_of_contract}}</td>
          <th>{{$t('term_of_agreement')}}</th>
          <td>{{propertyDetail.term_of_agreement}}</td>
        </tr>
        <tr>
          <th>{{$t('contract_deadline')}}</th>
          <td>{{propertyDetail.contract_deadline}}</td>
          <th>{{$t('type_of_borrower')}}</th>
          <td>{{propertyDetail.type_of_borrower}}</td>
        </tr>
        <tr>
          <th>{{$t('form_of_transaction')}}</th>
          <td>{{propertyDetail.form_of_transaction}}</td>
          <th>{{$t('update_type')}}</th>
          <td>{{propertyDetail.update_type}}</td>
        </tr>
        <tr>
          <th>{{$t('facility')}}</th>
          <td colspan="3">{{propertyDetail.facility}}</td>
        </tr>
        <tr>
          <th>{{$t('vendor_assignment')}}</th>
          <td colspan="3">{{propertyDetail.vendor_assignment}}</td>
        </tr>
        <tr>
          <th>{{$t('condition')}}</th>
          <td>{{propertyDetail.condition}}</td>
          <th>{{$t('remarks')}}</th>
          <td>{{propertyDetail.remarks}}</td>
        </tr>
        <tr>
          <th>{{$t('provided_on')}}</th>
          <td>{{formatDate(propertyDetail.provided_on)}}</td>
          <th>{{$t('next_update_on')}}</th>
          <td>{{formatDate(propertyDetail.next_update_on)}}</td>
        </tr>
      </template>
      <template v-if="propertyDetail.type === 'rental-commercial'">
        <tr>
          <th>{{$t('nearest_station')}}</th>
          <td colspan="3">{{propertyDetail.nearest_station}}</td>
        </tr>
        <tr>
          <th>{{$t('rent')}}（{{$t('administrative_fee')}}）</th>
          <td>{{propertyDetail.rent}}{{propertyDetail.administrative_fee ? `（${propertyDetail.administrative_fee}）`: ''}}</td>
          <th>{{$t('security_deposit')}}／{{$t('key_money')}}</th>
          <td v-html="ski_html"></td>
        </tr>
        <tr>
          <th>{{$t('other_fee')}}</th>
          <td v-html="sanitize(propertyDetail.other_fee)"></td>
          <th>{{$t('bearing')}}</th>
          <td>{{propertyDetail.bearing}}</td>
        </tr>
        <tr>
          <th>{{$t('property_type')}}／{{$t('construction')}}</th>
          <td v-html="pc_html"></td>
          <th>{{$t('building_floor_portion')}}</th>
          <td>{{propertyDetail.building_floor_portion}}</td>
        </tr>
        <tr>
          <th>{{$t('parking_lot')}}</th>
          <td>{{propertyDetail.parking_lot}}</td>
          <th>{{$t('date_of_construction')}}</th>
          <td>{{propertyDetail.date_of_construction}}</td>
        </tr>
        <tr>
          <th>{{$t('term_of_agreement')}}</th>
          <td>{{propertyDetail.term_of_agreement}}</td>
          <th>{{$t('form_of_transaction')}}</th>
          <td>{{propertyDetail.form_of_transaction}}</td>
        </tr>
        <tr>
          <th>{{$t('vendor_assignment')}}</th>
          <td>{{propertyDetail.vendor_assignment}}</td>
          <th>{{$t('tsubo_rent')}}</th>
          <td>{{propertyDetail.tsubo_rent}}</td>
        </tr>
        <tr>
          <th>{{$t('tsubo_management_fee')}}</th>
          <td>{{propertyDetail.tsubo_management_fee}}</td>
          <th>{{$t('guarantee_deposit')}}</th>
          <td>{{propertyDetail.guarantee_deposit}}</td>
        </tr>
        <tr>
          <th>{{$t('amortization')}}</th>
          <td>{{propertyDetail.amortization}}</td>
          <th>{{$t('insurance')}}</th>
          <td>{{propertyDetail.insurance}}</td>
        </tr>
        <tr>
          <th>{{$t('occupied_area')}}</th>
          <td>{{propertyDetail.occupied_area}}</td>
          <th>{{$t('land_area')}}</th>
          <td>{{propertyDetail.land_area}}</td>
        </tr>
        <tr>
          <th>{{$t('total_unit')}}</th>
          <td>{{propertyDetail.total_unit}}</td>
          <th>{{$t('delivery_time')}}</th>
          <td>{{propertyDetail.delivery_time}}</td>
        </tr>
        <tr>
          <th>{{$t('current_situation')}}</th>
          <td>{{propertyDetail.current_situation}}</td>
          <th>{{$t('assignment_of_fixture')}}</th>
          <td>{{propertyDetail.assignment_of_fixture}}</td>
        </tr>
        <tr>
          <th>{{$t('area_of_use')}}</th>
          <td>{{propertyDetail.area_of_use}}</td>
          <th>{{$t('special_remarks')}}</th>
          <td>{{propertyDetail.special_remarks}}</td>
        </tr>
        <tr>
          <th>{{$t('openable_industry')}}</th>
          <td>{{propertyDetail.openable_industry}}</td>
          <th>{{$t('interior_condition')}}</th>
          <td>{{propertyDetail.interior_condition}}</td>
        </tr>
        <tr>
          <th>{{$t('roadside_situation')}}</th>
          <td colspan="3">{{propertyDetail.roadside_situation}}</td>
        </tr>
        <tr>
          <th>{{$t('facility')}}</th>
          <td colspan="3">{{propertyDetail.facility}}</td>
        </tr>
        <tr>
          <th>{{$t('condition')}}</th>
          <td colspan="3">{{propertyDetail.condition}}</td>
        </tr>
        <tr>
          <th>{{$t('remarks')}}</th>
          <td colspan="3">{{propertyDetail.remarks}}</td>
        </tr>
        <tr>
          <th>{{$t('provided_on')}}</th>
          <td>{{formatDate(propertyDetail.provided_on)}}</td>
          <th>{{$t('next_update_on')}}</th>
          <td>{{formatDate(propertyDetail.next_update_on)}}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
export default {
  props: [
    'propertyDetail'
  ],
  computed: {
    ski_html: function () {
      const values = []
      if (this.propertyDetail.security_deposit) values.push(this.$t('security_deposit') + ': ' + this.propertyDetail.security_deposit)
      if (this.propertyDetail.key_money) values.push(this.$t('key_money') + ': ' + this.propertyDetail.key_money)
      if (this.propertyDetail.intermediary_charge) values.push(this.$t('intermediary_charge') + ': ' + this.propertyDetail.intermediary_charge)
      return values.join('<br>')
    },
    rr_html: function () {
      const values = []
      if (this.propertyDetail.renewal_fee) values.push(this.$t('renewal_fee') + ': ' + this.propertyDetail.renewal_fee)
      if (this.propertyDetail.renewal_office_fee) values.push(this.$t('renewal_office_fee') + ': ' + this.propertyDetail.renewal_office_fee)
      return values.join('<br>')
    },
    pc_html: function () {
      const values = []
      if (this.propertyDetail.property_type) values.push(this.propertyDetail.property_type)
      if (this.propertyDetail.construction) values.push(this.propertyDetail.construction)
      return values.join('<br>')
    }
  },
  methods: {
    sanitize: function (text) {
      if (!text) return text
      return text.replace(/\n/g, '<br />')
    },
    formatPrice: function (price, withBracket = false) {
      const p = Number(price)

      if (Number.isNaN(p) || p === 0) return ''

      const priceString = p.toLocaleString() + ' ' + this.$t('yen')
      return withBracket ? `（${priceString}）` : priceString
    },
    formatDate: function (text) {
      if (!text) return text
      return text.replace(/-/g, '/')
    }
  }
}
</script>
